import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  PlainSelectionsReducer,
} from './common.js';

const MultipleChoiceSelectionsReducer = PlainSelectionsReducer;

const MultipleChoiceSelectionsAggregator = ({ responses }) =>
  (responses || []).reduce((acc, response) => {
    const { data } = response || {};
    const { value } = data || {};
    const categoryIds = Object.keys(value || {}) || [];

    if (!categoryIds.length) return acc;

    (value || []).forEach(v => {
      const choiceCount = acc[v] ? acc[v].count : 0;

      acc[v] = {
        value: v,
        count: choiceCount + 1,
      };
    });

    return acc;
  }, {});

export default {
  AggregateMap: GlobalAggregateMap(MultipleChoiceSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(MultipleChoiceSelectionsReducer),
};
